module.exports = __webpack_public_path__ + "static/media/teacher13.471c6a5e.png";